export default __webpack_public_path__ + "static/media/clipboard-bg.df9f2443.png";